import { useDidMount } from '@surveycake/rhooks';

/**
 * To remove the loading mask.
 */
export function removeLoading() {
  setTimeout(() => {
    if (!document.getElementById('loading')) {
      return;
    }

    document.querySelector('#loading .loading-icon')!.classList.add('removing');
    setTimeout(() => {
      document
        .querySelector('#loading .loading-logo')!
        .classList.add('removing');
      document.getElementById('loading')!.classList.add('removing');
      setTimeout(() => {
        if (document.getElementById('loading')!){
          document.body.removeChild(document.getElementById('loading')!);
        }
        document.body.classList.remove('freeze');
      }, 1200);
    }, 500);
  }, 1000);
}

export function useRemoveLoading() {
  useDidMount(removeLoading);
}
